window.HarriEngageServiceAPI = new (function () {
    var self = this;
    var _protected = BaseAPI.call(self);
    _protected.setApiUrl(publicConfiguration.HarriEngageServer);

    self.checkBrandLevelActivation = cacheService.cache(function (brandId) {
        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/level_activation', 'GET')
            .then(function (res) {
                if (res && res.data && res.status === 200) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });
        return defer.promise;
    })[0];

    self.getAvailableLocales = cacheService.cache(() => {
        const defer = $q.defer();

        _protected.request(`users/me/available_locales`, 'GET')
            .then(function (res) {
                if (res?.data && res?.status === 200) {
                    defer.resolve(res.data.data.available_locales);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });
        return defer.promise;
    })[0];

    self.getPreferredLocale = () => {
        const defer = $q.defer();

        _protected.request(`users/me/settings`, 'GET')
            .then(function (res) {
                if (res?.data && res?.status === 200) {
                    defer.resolve(res.data.data.preferred_locale);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });
        return defer.promise;
    };

    self.setPreferredLocale = (preferredLocale) => {
        const deferred = $q.defer();
        _protected.request(`users/me/settings`, 'PUT', preferredLocale)
            .then(function (res) {
                if (res?.data && res?.status === 200) {
                    deferred.resolve(res.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });
    }
});
